'use client';
import React, { useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import { useCartService } from '@/hooks/cart/useCartService';
import { LegacyCartIcon } from '@/assets/LegacyCartIcon';
import QueryBoundary from '@/components/ui/QueryBoundary';

const SHOPPING_BAG_BUTTON_TEST_ID = 'shopping-bag-button';

type ShoppingBagButtonProps = ComponentProps<typeof Flex>;

const ShoppingBagButton = ({ ...rest }: ShoppingBagButtonProps) => {
  return (
    <Flex cursor="pointer" data-testid={SHOPPING_BAG_BUTTON_TEST_ID} position="relative" {...rest}>
      <LegacyCartIcon cursor="pointer" height="24px" width="24px" />
      <Flex
        alignItems="center"
        backgroundColor="#027A48"
        borderRadius="14px"
        fontSize="10px"
        height="14px"
        justifyContent="center"
        position="absolute"
        right="-4px"
        top="-4px"
        width="14px"
      >
        <ClientSideCart />
      </Flex>
    </Flex>
  );
};

const ClientSideCart = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return <Text>0</Text>;
  }

  return (
    <QueryBoundary loadingFallback={<Text>0</Text>} errorFallback={<Text>0</Text>}>
      <ProductQuantity />
    </QueryBoundary>
  );
};

const ProductQuantity = () => {
  const { useGetCart } = useCartService();
  const { data } = useGetCart();

  const totalQuantity = data?.cart?.item?.reduce((prev, curr) => prev + curr.quantity, 0) || 0;

  return <Text>{totalQuantity}</Text>;
};

export default ShoppingBagButton;
